import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import { ErrorBoundary } from "react-error-boundary";
//
// eslint-disable-next-line import/no-cycle
import ErrorPage from "../error/ErrorPage";
//
// eslint-disable-next-line import/named
import {
  ROUTE_PATH,
  ERROR_CODE,
  LOG_CLASSIFICATION,
} from "../../config/CONSTANTS";
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";
// hooks
import useLocaleRoute from "../../common/hooks/useLocaleRoute";
// config, utils
import urls from "../../api/project/ApiUrls";
import fireDb from "../../api/firebase/realtime/utils";

const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <ErrorPage error={error} resetErrorBoundary={resetErrorBoundary} />
);

ErrorFallback.propTypes = {
  error: PropTypes.objectOf(PropTypes.any),
  resetErrorBoundary: PropTypes.func,
};

ErrorFallback.defaultProps = {
  error: null,
  resetErrorBoundary: () => null,
};

const ErrorCapture = ({ children }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  //
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale, displayName } = user;
  //
  const [crash, setCrash] = useState(false);

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const onRest = () => {
    // fixme: not working
    // navigate(handleLocaleRoute(ROUTE_PATH.Home));
  };

  const onError = (error, info) => {
    setCrash(true);
    const errObj = {
      code: ERROR_CODE.systemCrashError,
      message: error.message,
      userName: displayName || "",
      info,
      operation: "",
      classification: LOG_CLASSIFICATION.error,
    };
    dispatch({
      type: Act.ERROR_SET_ERROR,
      payload: {
        ...errObj,
      },
    });
    fireDb.creatLogError({
      data: {
        ...errObj,
      },
      onSuccess: (key) => {
        // 跳出訊息視窗
        dispatch({
          type: Act.COMMON_SET_SUCCESS_MESSAGE,
          payload: {
            open: true,
            content: intl.formatMessage({
              id: "errorcapture.send.success",
              defaultMessage: "傳送訊息成功",
            }),
          },
        });
      },
      onError: (err) => {
        // 跳出訊息視窗
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: intl.formatMessage({
              id: "errorcapture.send.failure",
              defaultMessage: "傳送訊息失敗",
            }),
          },
        });
      },
    });
    setTimeout(() => {
      navigate(handleLocaleRoute(ROUTE_PATH.SupportPage));
    }, 3000);
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={onError}
      onReset={onRest}
    >
      {children}
    </ErrorBoundary>
  );
};

ErrorCapture.propTypes = {
  children: PropTypes.node,
};

ErrorCapture.defaultProps = {
  children: null,
};

export default ErrorCapture;
